import { render, staticRenderFns } from "./FlightsPopUp.vue?vue&type=template&id=24cc6d95&scoped=true&"
import script from "./FlightsPopUp.vue?vue&type=script&lang=js&"
export * from "./FlightsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./FlightsPopUp.vue?vue&type=style&index=0&id=24cc6d95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cc6d95",
  null
  
)

export default component.exports